import { useQuery } from "@pinia/colada";
import { computed } from "vue";

import { toApiLocale, useWidgetContext } from "@/shared/config";
import { useApiGetWidgetData } from "@/shared/model";

import { apiGetStatusQuestion } from "../api";
import { useEvaluationStore } from "./evaluation";

/** Вопрос о состоянии зарегистрированного устройства */
export function useApiGetStatusQuestion() {
    const { settings } = useWidgetContext();
    const { data: widgetData } = useApiGetWidgetData();
    const evaluationStore = useEvaluationStore();

    const token = computed(() => widgetData.value?.token ?? "");
    const lang = toApiLocale(settings.locale);

    return useQuery(() => {
        const deviceId = evaluationStore.registeredDevice?.deviceId ?? "";

        return {
            key: ["status-question", deviceId, lang],
            query: () => apiGetStatusQuestion({ deviceId, token: token.value, lang }),
            enabled: Boolean(token.value && deviceId),
            // The question doesn't change for a registered device
            staleTime: Infinity,
            refetchOnWindowFocus: false,
            refetchOnReconnect: false,
        };
    });
}
